import { gql } from '@apollo/client';

const DELETE_CATEGORY_MUTATION = gql`
    mutation deleteCategory($input: DeleteCategoryInput!) {
        result: deleteCategory(input: $input) {
            affectedRows
        }
    }
`;

export default DELETE_CATEGORY_MUTATION;
 